import { PurchaseOrder } from "@/gen/purchase_order/common_pb";
import { PDFRoot, PDFHead, PDFBody, PDFTable, PDFTableRow } from "./composable-pdf";
import { Text, View } from "@react-pdf/renderer";
import parsePhoneNumber from 'libphonenumber-js'
import { convertToCurrencyRounded } from "@/utils/currency_converter";

export default function POPDF({poData}: {
  poData: PurchaseOrder
}) {

  const pharmacyInfo = localStorage.getItem("pharmacyMetadata") ? JSON.parse(localStorage.getItem("pharmacyMetadata")!) : null;
  const pharmacyLocationDetails = localStorage.getItem("pharmacyLocationDetails") ? JSON.parse(localStorage.getItem("pharmacyLocationDetails")!) : null;

  return (
    <PDFRoot>
      {/* Header */}
      <PDFHead>
        <View style={{ flex: 1, flexDirection: "row", justifyContent: "space-between", alignItems: "flex-start", width: "100%", paddingTop: 24 }}>
          <View style={{ flexDirection: "column" }}>
            <Text style={{ fontSize: 20, fontWeight: 700, marginBottom: 12 }}>Purchase Order</Text>
            <Text style={{ fontWeight: 700, fontSize: 14 }}>{pharmacyInfo.pharmacyName}</Text>
            {/* <Text style={{ fontSize: 10 }}>{quotationData.company.license}</Text> */}
            {pharmacyInfo.taxIdentifiers.map((tax: any) => (
              <Text key={tax.type} style={{ fontSize: 10 }}>{tax.type}: {tax.value}</Text>
            ))}
            <Text style={{ fontSize: 10 }}>{pharmacyInfo.email} | {parsePhoneNumber(pharmacyInfo.primaryPhone, pharmacyInfo.countryCode)!.formatInternational()}</Text>
            <View style={{ height: 24 }} />
            <Text style={{ fontWeight: 700, fontSize: 13 }}>{poData.supplierName}</Text>
            <Text style={{ fontSize: 10 }}>{poData.supplierMetadata?.taxIdentifier?.type}: {poData.supplierMetadata?.taxIdentifier?.value}</Text>
            <Text style={{ fontSize: 10 }}>{poData.supplierMetadata?.city}, {poData.supplierMetadata?.state}, {poData.supplierMetadata?.country}</Text>
            <Text style={{ fontSize: 10 }}>{parsePhoneNumber(poData.supplierMetadata?.phoneNumber!, pharmacyInfo.countryCode)!.formatInternational()}</Text>
          </View>
          <View style={{ alignItems: "flex-end" }}>
            <Text style={{ fontSize: 12 }}>Date:{
              poData.createdAt?.toDate().toLocaleDateString("en-US", {
                year: "numeric",
                month: "long",
                day: "numeric"
              })  
            }</Text>
            <Text style={{ fontSize: 12, fontWeight: 700 }}>Order Number: {poData.orderNumber}</Text>
          </View>
        </View>
      </PDFHead>
      {/* Table */}
      <PDFBody>
        <View style={{ border: "1pt solid #d9d9d9", borderBottom: 0, borderRadius: 6, overflow: "hidden", marginTop: 24 }}>
          {/* Table Head */}
          <PDFTableRow className="font-bold text-[11pt]">
            <Text style={{ flex: 2.5, padding: 6 }}>Trade Name</Text>
            <Text style={{ flex: 1.5, padding: 6, textAlign: "center" }}>Qty</Text>
            <Text style={{ flex: 1.5, padding: 6, textAlign: "center" }}>Bonus</Text>
            <Text style={{ flex: 2, padding: 6, textAlign: "center" }}>Cost</Text>
            <Text style={{ flex: 2, padding: 6, textAlign: "center" }}>Total Amount (Excl. Tax)</Text>
          </PDFTableRow>
          {/* Table Body */}
          {poData.items.map((item, idx) => (
            <PDFTableRow key={idx} className="text-[10pt]">
              <Text style={{ flex: 3, padding: 6 }}>{item.tradeName} {item.unit} {item.unitType}</Text>
              <Text style={{ flex: 1, padding: 6, textAlign: "center" }}>{item.quantity}</Text>
              <Text style={{ flex: 2, padding: 6, textAlign: "center" }}>{item.bonusQuantity}</Text>
              <Text style={{ flex: 2, padding: 6, textAlign: "center" }}>{convertToCurrencyRounded(item.unitPrice)}</Text>
              <Text style={{ flex: 2, padding: 6, textAlign: "center" }}>{convertToCurrencyRounded(item.unitPrice * item.quantity)}</Text>
            </PDFTableRow>
          ))}
        </View>
        {/* Totals */}
        <View style={{ flexDirection: "row", justifyContent: "flex-end", marginTop: 12 }}>
          <View style={{ width: 280, border: "1pt solid #d9d9d9", borderRadius: 6, padding: 16 }}>
            <View style={{ flexDirection: "row", justifyContent: "space-between", alignItems: "center", marginTop: 8 }}>
              <Text style={{ fontSize: 12, fontWeight: 700 }}>Total Order Value:</Text>
              <Text style={{ fontSize: 12, fontWeight: 900 }}>{
                convertToCurrencyRounded(poData.items.reduce((total, item) => total + (item.unitPrice * item.quantity), 0))
                }</Text>
            </View>
          </View>
        </View>
        {/* Deliver Instructions */}
        <View style={{ marginTop: 40 }}>
          <Text style={{ color: "#8b5cf6", fontWeight: 700, fontSize: 11, marginBottom: 4 }}>DELIVERY INSTRUCTIONS</Text>
          <Text style={{ fontSize: 10 }}></Text>
          <Text style={{ fontSize: 10 }}>Delivery Address: </Text>
          <Text style={{ fontSize: 10 }}>{pharmacyLocationDetails.address}</Text>
        </View>
      </PDFBody>
    </PDFRoot>
  );
}
